var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGifBadgesmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 0h9c.83 0 1.5.67 1.5 1.5v9c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 0 1 0 10.5v-9C0 .67.67 0 1.5 0Zm2.33 8.3c-1.23 0-1.9-.76-1.9-1.87 0-1.05.57-1.97 1.92-1.97.49 0 .8.09 1.05.2v.7c-.3-.14-.6-.22-1-.22-.73 0-1.1.46-1.1 1.29 0 .8.39 1.2 1.07 1.2.19 0 .3-.02.43-.06v-.74h-.58v-.61h1.37v1.86c-.32.11-.7.22-1.26.22ZM6 8.25V4.51h.82v3.74H6Zm1.78 0V4.51h2.3v.68H8.62v.87h1.3v.62h-1.3v1.57h-.83Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGifBadgesmall);
export default __webpack_public_path__ + "static/media/gifBadge.small.69911b7cd43b1da94efe71ecef98e620.svg";
export { ForwardRef as ReactComponent };